<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <ng-container *ngIf="isPaymentForm || isEDUModalWidget || isCartForm || isModalForm">
                <div class="form-group mb-20">
                    <label *ngIf="!isCartForm" class="col-xs-9 control-label">
                        {{ "control_form_modal_background" | translate }}
                    </label>
                    <label *ngIf="isCartForm" class="col-xs-9 control-label">
                        {{ "control_form_background" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <img
                            class="refresh-btn"
                            [tooltip]="refreshTooltip"
                            [tooltipAppendToBody]="true"
                            *ngIf="modalBackgroundColor.value !== defaultModalBackgroundColor && !isCartForm"
                            (click)="setModalBackgroundColor({ value: defaultModalBackgroundColor })"
                            src="./assets/img/websites/lpc-return-icon.svg"
                        />
                        <ng-template #refreshTooltip>
                            {{ "refresh_modal_background_color" | translate }}
                        </ng-template>
                        <sp-color-picker
                            [color]="modalBackgroundColor.value"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setModalBackgroundColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">
                        {{ "control_radius" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-input-num
                            prefixImgUrl="./assets/img/border-radius-icon.svg"
                            suffixText="px"
                            [min]="BORDER_RADIUS_MIN"
                            [max]="BORDER_RADIUS_MAX"
                            [value]="modalBorderRadius.value"
                            (valueChange)="setModalBorderRadius($event)"
                            (blurEvent)="setModalBorderRadius($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <div class="form-group mb-20" *ngIf="isPaymentForm || isEDUModalWidget || isCartForm || isModalForm">
                    <label class="col-xs-7 control-label">
                        {{ "control_padding" | translate }}
                    </label>
                    <div class="col-xs-5">
                        <sp-input-num
                            suffixText="px"
                            [min]="PADDING_MIN"
                            [max]="PADDING_MAX"
                            [value]="modalPadding.value"
                            (valueChange)="setModalPadding($event)"
                            (blurEvent)="setModalPadding($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <div *ngIf="!isCartForm && !isModalForm" class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_form_text_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            [color]="textColor.value"
                            (colorChangeEvent)="setTextColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>
                <div class="form-group mb-0">
                    <hr class="panel-options-divider" />
                </div>
            </ng-container>

            <ng-container *ngIf="(isModalForm && isTwoStepForm) || !isModalForm">
                <div *ngIf="isTwoStepForm" class="form-group mb-0">
                    <div class="title">{{ "control_static_form_title" | translate }}</div>
                </div>

                <div class="form-group mb-20" *ngIf="!isLoginForm && !isCartForm">
                    <label class="col-xs-9 control-label">
                        {{ "control_fields_name" | translate }}
                    </label>
                    <div class="col-xs-3 text-right control-switch">
                        <sp-switch
                            [active]="showLabels.value"
                            (toggleActiveEvent)="setIsShowFieldsName($event)"
                        ></sp-switch>
                    </div>
                </div>

                <div *ngIf="showLabels.value && !(isPaymentForm || isEDUModalWidget)" class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_label_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            [color]="textColor.value"
                            (colorChangeEvent)="setTextColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20" *ngIf="!isPaymentForm && !isLoginForm && !isCartForm">
                    <label class="col-xs-12">
                        {{ "control_fields_position" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <div class="btn-group d-flex">
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="formStyleType.value === formStyleEnum.VERTICAL"
                                (click)="setFormStyleType(formStyleEnum.VERTICAL)"
                            >
                                <img src="./assets/img/websites/lpc-form-vertical-icon.svg" alt="vertical-form" />
                            </button>
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="formStyleType.value === formStyleEnum.HORIZONTAL"
                                (click)="setFormStyleType(formStyleEnum.HORIZONTAL)"
                            >
                                <img src="./assets/img/websites/lpc-form-horizontal-icon.svg" alt="horizontal-form" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_fields_appearance" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <div class="btn-group d-flex">
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="inputBorderType.value === inputBorderEnum.FULL_BORDER"
                                (click)="setInputBorderType(inputBorderEnum.FULL_BORDER)"
                            >
                                <img src="./assets/img/websites/lpc-full-border-icon.svg" alt="center-icon" />
                            </button>
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="inputBorderType.value === inputBorderEnum.BOTTOM_BORDER"
                                (click)="setInputBorderType(inputBorderEnum.BOTTOM_BORDER)"
                            >
                                <img src="./assets/img/websites/lpc-bottom-border-icon.svg" alt="left-icon" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_input_text_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="inputTextColor.value"
                            (colorChangeEvent)="setInputTextColor($event)"
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_background_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="backgroundColor.value"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setThemeBackgroundColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">
                        {{ "control_radius" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-input-num
                            prefixImgUrl="./assets/img/border-radius-icon.svg"
                            suffixText="px"
                            [class.disabled]="isDisabled"
                            [min]="BORDER_RADIUS_MIN"
                            [max]="BORDER_RADIUS_MAX"
                            [value]="borderRadius.value"
                            (valueChange)="setBorderRadius($event)"
                            (blurEvent)="setBorderRadius($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_border_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="borderColor.value"
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setBorderColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="control-label col-xs-6">
                        {{ "control_fields_size" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-radio-group
                            [selected]="inputSize.value"
                            [type]="radioGroupType.size"
                            (changeSelectedEvent)="setInputSize($event)"
                        ></sp-radio-group>
                    </div>
                </div>

                <div class="form-group" *ngIf="isLoginForm">
                    <label class="col-xs-9 control-label">
                        {{ "control_link_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="linkColor.value"
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setLinkColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="isModalForm">
                <div *ngIf="isTwoStepForm" class="form-group mb-0">
                    <hr class="panel-options-divider" />

                    <div class="title">{{ "control_modal_form_title" | translate }}</div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_form_text_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            [color]="modalTitleTextColor.value"
                            (colorChangeEvent)="setModalTitleTextColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_fields_name" | translate }}
                    </label>
                    <div class="col-xs-3 text-right control-switch">
                        <sp-switch
                            [active]="modalShowLabels.value"
                            (toggleActiveEvent)="setIsModalShowFieldsName($event)"
                        ></sp-switch>
                    </div>
                </div>

                <div *ngIf="modalShowLabels.value" class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_label_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            [color]="modalTextColor.value"
                            (colorChangeEvent)="setModalTextColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-12">
                        {{ "control_fields_appearance" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <div class="btn-group d-flex">
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="modalInputBorderType.value === inputBorderEnum.FULL_BORDER"
                                (click)="setModalInputBorderType(inputBorderEnum.FULL_BORDER)"
                            >
                                <img src="./assets/img/websites/lpc-full-border-icon.svg" alt="center-icon" />
                            </button>
                            <button
                                class="btn btn-grey w-100"
                                [class.active]="modalInputBorderType.value === inputBorderEnum.BOTTOM_BORDER"
                                (click)="setModalInputBorderType(inputBorderEnum.BOTTOM_BORDER)"
                            >
                                <img src="./assets/img/websites/lpc-bottom-border-icon.svg" alt="left-icon" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_input_text_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="modalInputTextColor.value"
                            (colorChangeEvent)="setModalInputTextColor($event)"
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_background_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="modalInputBackgroundColor.value"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setThemeModalInputBackgroundColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-6 control-label">
                        {{ "control_radius" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-input-num
                            prefixImgUrl="./assets/img/border-radius-icon.svg"
                            suffixText="px"
                            [class.disabled]="isDisabled"
                            [min]="BORDER_RADIUS_MIN"
                            [max]="BORDER_RADIUS_MAX"
                            [value]="modalInputBorderRadius.value"
                            (valueChange)="setModalInputBorderRadius($event)"
                            (blurEvent)="setModalInputBorderRadius($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_border_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <sp-color-picker
                            [color]="modalInputBorderColor.value"
                            [hideGradient]="true"
                            [colorsPreset]="selectedThemeColors()"
                            (colorChangeEvent)="setModalInputBorderColor($event)"
                        ></sp-color-picker>
                    </div>
                </div>

                <div class="form-group">
                    <label class="control-label col-xs-6">
                        {{ "control_fields_size" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-radio-group
                            [selected]="modalInputSize.value"
                            [type]="radioGroupType.size"
                            (changeSelectedEvent)="setModalInputSize($event)"
                        ></sp-radio-group>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
